import cn from '@sindresorhus/class-names';
import {CSSProperties, FunctionComponent} from 'react';

import styles from './SkeletonBasic.module.scss';

const toPx = (val: number | string | undefined) => {
  if (typeof val === 'number') {
    return val + 'px';
  }

  return val;
};

type Props = {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  radius?: CSSProperties['borderRadius'];
  className?: string;
};

export const SkeletonBasic: FunctionComponent<Props> = (props) => {
  const {radius, width, height, className} = props;

  return (
    <div
      style={
        {
          '--border-radius': toPx(radius),
          '--width': toPx(width),
          '--height': toPx(height),
        } as CSSProperties
      }
      className={cn(className, styles.line)}
    ></div>
  );
};
